import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import phpMyadmin from './assets/images/phpmyadmin.jpeg';



const PhpLesson14 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `

        `
      );







  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>MySQL Database Setup</strong></h3>
      <p>Setting up a database in <b>phpMyAdmin</b> involves the following steps:</p>

  <p><b>1. Open phpMyAdmin: You can open phpMyAdmin by going to the URL http://localhost/phpmyadmin (assuming that you have it installed on your local machine). If you are accessing it on a remote server, replace localhost with the server's IP or hostname.</b></p>
  <p><b>2. Log in to phpMyAdmin using your MySQL root username and password.</b></p>
  <p><b>3. In the main menu, click on the "Databases" tab</b>.</p>
  <p><b>4. In the "Create new database" section, enter a name for your new database and select the desired encoding</b>.</p>
  <p><b>5. Click on the "Create" button to create the new database.</b></p>

  <p><b>6. Once the database is created, you can start creating tables and inserting data into them. You can also use the "Import" feature to import data from a SQL file.</b></p>
  <p><b>7. To create a new user and assign them privileges to the database, go to the "Users" tab and add a new user, by setting a username and a password, then set the privileges of the user to the new created database..</b></p>
  <p><b>8. Once you've set up your database, you can use PHP to connect to it and execute SQL commands to insert, update, and retrieve data. You will need to use the MySQLi or PDO extension in PHP to connect to the database and run SQL commands.</b>.</p>

  <p>Your PhpMyAdmin dashboard should look like this</p>
      <img src={phpMyadmin} alt="phpmyadim" class="img-fluid mb-4" />
      <p>Next, we are going to see how to create tables in our database.</p>




    </div>




    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson14
